<template lang="pug">
v-card(v-if="products.length")
  v-card-title
    span Utilización de capacidad
    ShowInfoBtn(@click="$refs.infoAlert.showAlert()")
  v-card-text
    InfoAlert(:message="alertMessage" ref="infoAlert")
    v-alert(dense text :color="overallColor" border="left" class="mb-4")
      span(v-html="message")
    .cap-row(v-for="p in products" :key="p.product_name")
      .cap-head
        span.cap-name {{ pretty(p.product_name) }}
        span.cap-pct {{ p.utilization != null ? p.utilization.toFixed(0) + '%' : 'Sin tope' }}
      .cap-track: .cap-fill(:style="{ width: Math.min(100, p.utilization || 0) + '%', background: barColor(p.utilization) }")
</template>

<script>
import { mapActions } from 'vuex'
import InfoAlert from '../../common/InfoAlert.vue'
import ShowInfoBtn from '../../common/ShowInfoBtn.vue'

export default {
  props: {
    filters: { type: Object, required: true, default: () => ({}) },
    projection: { type: Number, default: null },
  },
  components: { InfoAlert, ShowInfoBtn },
  data() {
    return {
      overall: null,
      products: [],
      alertMessage: `
<p>
Muestra <b>cuánto de tu capacidad de producción estás usando</b> en el mix óptimo. Si te sobra capacidad, puedes crecer sin invertir en máquinas; si algún producto está al tope, ahí el modelo tuvo que priorizar. Capacidad anual = capacidad mensual × 12.
</p>`,
    }
  },
  computed: {
    overallColor() {
      if (this.overall == null) return 'info'
      if (this.overall >= 90) return 'warning'
      return 'success'
    },
    message() {
      if (this.overall == null) return 'Ninguno de estos productos o servicios tiene una capacidad máxima declarada, así que el mix óptimo no está limitado por capacidad. Si tienes un tope real (horas, visitas o proyectos al mes), decláralo en Productos y servicios para ver cuánto de tu capacidad estás usando.'
      const libre = Math.max(0, 100 - this.overall)
      if (this.overall >= 90) {
        return `Estás usando el <b>${this.overall.toFixed(0)}%</b> de tu capacidad: tu fábrica está casi al tope. Para crecer necesitarías invertir en producción o priorizar tus productos de mayor margen.`
      }
      return `Estás usando el <b>${this.overall.toFixed(0)}%</b> de tu capacidad: te sobra un <b>${libre.toFixed(0)}%</b>. Puedes crecer en ventas sin invertir en máquinas.`
    },
  },
  methods: {
    ...mapActions('commercial_projection', ['getCapacityUtilization']),
    pretty(n) { return n ? n.charAt(0) + n.slice(1).toLowerCase() : '' },
    barColor(u) {
      if (u == null) return '#B9C4CC'
      if (u >= 90) return '#C9821B'
      return '#19BFA7'
    },
    async fetchData() {
      const params = { ...this.filters, projection: this.projection || this.$route.params.id }
      const { data, error } = await this.getCapacityUtilization(params)
      if (!error && data) {
        this.overall = data.overall
        this.products = data.products || []
      }
    },
  },
  watch: {
    filters: { handler() { this.fetchData() }, deep: true },
  },
  created() { this.fetchData() },
}
</script>

<style scoped>
.cap-row { margin-bottom: 11px; }
.cap-head { display: flex; justify-content: space-between; font-size: 13px; margin-bottom: 3px; }
.cap-pct { font-weight: 700; color: #4A5A66; font-variant-numeric: tabular-nums; }
.cap-track { height: 8px; background: #F0F2F7; border-radius: 5px; overflow: hidden; }
.cap-fill { height: 100%; border-radius: 5px; transition: width .3s ease; }
</style>
